export const MODAL_NAMES = {
  DeleteScenarioObligationModal: 'DeleteScenarioObligationModal',
};
